export default __webpack_public_path__ + "static/media/review_video_background.af392d28.jpg";